export const enum ThongTinDoAnName {
  MaQuanHuyen = 'MaQuanHuyen',
  MaPhuongXa = 'MaPhuongXa',
  ChuDauTu='ChuDauTu',
  LoaiQuyHoach = 'LoaiQuyHoach',
  TenDuAn = 'TenDuAn',
  MaDuAn = 'MaDuAn',
  TrangThaiPheDuyetQuyHoach = 'TrangThaiPheDuyetQuyHoach',
  TienDoDuAn = 'TienDoDuAn',
  TinhTrangPheDuyet = 'TinhTrangPheDuyet',
  TGDangKyCDT = 'TGDangKyCDT',
  TGQHXinPheDuyet = 'TGQHXinPheDuyet',
  TGQHThongTinQH = 'TGQHThongTinQH',
  TGQHLayYKien = 'TGQHLayYKien',
  TGQHCongBo = 'TGQHCongBo',
  NoiDungChuTruong='NoiDungChuTruong',
  NoiDungKinhDoanhBDS = 'NoiDungKinhDoanhBDS',
  TGChuTruong = 'TGChuTruong',
  TGThamDinhThietKe = 'TGThamDinhThietKe',
  TGCapPhepXayDung = 'TGCapPhepXayDung',
  TGNghiemThu = 'TGNghiemThu',
  TGKinhDoanhBDS = 'TGKinhDoanhBDS',
  DienTich='DienTich',
  PhanLoaiDuAn='PhanLoaiDA'
}

export interface DoAnQuyHoach {
  loaiQuyHoach: DM_TTDA_LoaiQuyHoach,
  doAns: ThongTinDoAn[]
}


export default interface ThongTinDoAn {
  OBJECTID?: number;
  MaQuanHuyen?: string;
  MaPhuongXa?: string;
  DienTich?:number;
  MaDuAn?: string;
  LoaiQuyHoach?: DM_TTDA_LoaiQuyHoach;
  TenDuAn?: string;
  KyHieuLoDat?:string;
  KyHieuODat?:string,
  ChuDauTu?: string;
  // DienTich?: number;
  TrangThaiPheDuyetQuyHoach?: DM_TTDA_TrangThaiPheDuyetQuyHoach;
  TienDoDuAn?: DM_TTDA_TienDoDuAn;
  TinhTrangPheDuyet?: DM_TTADA_TinhTrangPheDuyet;
  TGDangKyCDT?: number;
  TGQHXinPheDuyet?: number;
  TGQHThongTinQH?: number;
  TGQHLayYKien?: number;
  TGQHCongBo?: number;
  NoiDungKinhDoanhBDS?: string;
  TGChuTruong?: number;
  TGThamDinhThietKe?: number;
  TGCapPhepXayDung?: number;
  TGNghiemThu?: number;
  TGKinhDoanhBDS?: number;
  NoiDungChuTruong?: string;
  PhanLoaiDuAn?:string;
}

export enum DM_TTDA_LoaiQuyHoach {
  'QuyHoachChungTinh' = '10',
  'QuyHoachChungDoThi' = '11',
  'QuyHoachPhanKhu' = '20',
  'QuyHoachNTM' = '30',
  'QuyHoachChiTiet' = '50'
}
export const LoaiQuyHoach = [
  { code: DM_TTDA_LoaiQuyHoach.QuyHoachChungTinh, value: 'Quy hoạch chung tỉnh' },
  { code: DM_TTDA_LoaiQuyHoach.QuyHoachChungDoThi, value: 'Quy hoạch chung đô thị' },
  { code: DM_TTDA_LoaiQuyHoach.QuyHoachPhanKhu, value: 'Quy hoạch phân khu' },
  { code: DM_TTDA_LoaiQuyHoach.QuyHoachNTM, value: 'Quy hoạch nông thôn mới' },
  { code: DM_TTDA_LoaiQuyHoach.QuyHoachChiTiet, value: 'Quy hoạch chi tiết' }
]

export enum DM_TTDA_TrangThaiPheDuyetQuyHoach {
  'ThongTin' = 'TTQH',
  'LayYKien' = 'LYKQH',
  'CongBo' = 'CBQH',
}
export enum DM_TTDA_TienDoDuAn {
  DangKyChuDauTu = '1',
  XinPheDuyetQH = '2.1',
  DaPheDuyetQH = '2.2',
  ChuaCoChuTruong = '3.1',
  DaCoChuTruong = '3',
  DaThamDinhThietKeHDXD = '4.1',
  DaThamDinhThietKeHTKT = '4.2',
  DaThamDinh = '4',
  DaCapPhepXayDungHDXD = '5.1.1',
  DaCapPhepXayDungHTKT = '5.1.2',
  DaCapPhepXayDung = '5.1',
  DaNghiemThuHDXD = '5.2',
  DaNghiemThuHTKT = '5.3',
  DaNghiemThu = '5',
  KinhDoanhBDS = '6',

}
export enum DM_TTADA_TinhTrangPheDuyet {
  ChuaDuyet, DaDuyet
}